var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"elevation-0 mx-2",attrs:{"color":"#009900","dark":""},on:{"click":_vm.gerarExcel}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v(" article ")]),_vm._v(" Gerar Excel ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }